import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';

import I18n from '../I18n';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		padding: theme.spacing(3, 2, 3, 2),
		marginBottom: theme.spacing(5),
		backgroundColor: grey[100]
	},
	type: {
		fontWeight: 400,
		[theme.breakpoints.down('xs')]: {
			fontSize: '1.2rem'
		}
	}
}));
const AboutEcordum = () => {
	const classes = useStyles();
	return (
		<div className={classes.root}>
			<Typography className={classes.type} variant="h6" align="center">
				{I18n('home.slogan')}
			</Typography>
		</div>
	);
};

export default AboutEcordum;
